module.exports = __webpack_public_path__ + "static/media/success.2848edb0.svg";